import { gql } from "@apollo/client";

export const APROBAR_LIQUIDACION_PROFESIONAL = gql`
    mutation generarOrdenOC($input: [LiquidacionFinalInput!]!) {
        generarOrdenOC(input: $input){
            success
            error
            valorEsperado
        }
    }
`;

/**List<LiquidacionFinalInput> input
 * public class LiquidacionFinalInput
{
    public int IdLiquidacionProfesional { get; set; }
    public IList<DetalleCuentaModel> DetalleCuenta { get; set; }
}
public class DetalleCuentaModel
{
    public string Cuenta { get; set; } = string.Empty;
    public string CentroCosto { get; set; } = string.Empty;
    public string CentroAlmacenamiento { get; set; } = string.Empty;
    public string DescripcionServicio { get; set; } = string.Empty;
    public double LiquidacionTotal { get; set; }
}
 */